import { STICKY_HEADER_HEIGHT_DEFAULT, STICKY_HEADER_HEIGHT_MOBILE, } from '@yme/components/Header/constants';
import { useWindowSize } from './useWindowSize';
export function useMenuHeight() {
    const { isMobileView } = useWindowSize();
    return isMobileView ? STICKY_HEADER_HEIGHT_MOBILE : STICKY_HEADER_HEIGHT_DEFAULT;
}
